import {
    __read,
    __spreadArray
} from 'tslib';
export var timeoutProvider = {
    setTimeout: function (_setTimeout) {
        function setTimeout(_x, _x2) {
            return _setTimeout.apply(this, arguments);
        }
        setTimeout.toString = function () {
            return _setTimeout.toString();
        };
        return setTimeout;
    }(function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout.apply(delegate, __spreadArray([
                handler,
                timeout
            ], __read(args)));
        }
        return setTimeout.apply(void 0, __spreadArray([
            handler,
            timeout
        ], __read(args)));
    }),
    clearTimeout: function (_clearTimeout) {
        function clearTimeout(_x3) {
            return _clearTimeout.apply(this, arguments);
        }
        clearTimeout.toString = function () {
            return _clearTimeout.toString();
        };
        return clearTimeout;
    }(function (handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    }),
    delegate: undefined
};